<template>
  <div class="row">
    <!--  审核课程列表  -->
    <div class="flex xs12">
      <va-card title="审核课程">
        <!--   课程类型筛选     -->
        <div class="row align-center mb-1">
          <div class="flex xs12">
            <va-button-group>
              <va-button class="mb-2" flat disabled color="gray" >课程类型:</va-button>
              <va-button  class="mb-2" flat :color="serviceType ? 'gray' : 'info'" v-on:click="handleServiceTypeChange(null)">全部</va-button>
              <va-button
                class="mb-2"
                v-for="courseType in courseTypes"
                :key="courseType.CODE"
                :color="computeCourseTypeColor(courseType.CODE)"
                flat
                v-on:click="handleServiceTypeChange(courseType.CODE)"
              >{{courseType.TEXT}}</va-button>
            </va-button-group>
            <va-button-group>
              <va-button class="mb-2" disabled flat color="gray">处理状态:</va-button>
              <va-button
                class="mb-2"
                v-for="auditStatus in serviceAuditTypes"
                v-show="auditStatus.CODE!==0"
                :key="auditStatus.CODE"
                :color="computeAuditStatusColor(auditStatus.CODE)"
                flat
                v-on:click="handleAuditStatusChange(auditStatus.CODE)" >{{auditStatus.TEXT}}</va-button>
            </va-button-group>
            <va-button class="mb-2" flat disabled color="danger">总计{{totalCount}}条结果</va-button>
          </div>
        </div>
        <va-data-table
          :fields="fields"
          :data="auditingCourses"
          :loading="loading"
          :totalPages="totalPages"
          @page-selected="listAuditingCourse"
          api-mode
        >
          <!-- 导师名字 -->
          <template slot="mentorName" slot-scope="props">
            <va-button flat small color="gray" :to='{path:`/admin/mentors/getMentor/${props.rowData.mentor.mentorUid}`}'>
              {{ props.rowData.mentor.nickname }}
            </va-button>
          </template>
          <template slot="serviceTypeSlot" slot-scope="props">
            <va-badge :color=computeCourseType(props.rowData.serviceType).color>
              {{ computeCourseType(props.rowData.serviceType).text }}
            </va-badge>
          </template>
          <template slot="auditStatusSlot" slot-scope="props">
            <va-badge :color=computeStatus(props.rowData.auditStatus).color>
              {{ computeStatus(props.rowData.auditStatus).text }}
            </va-badge>
          </template>
          <template slot="applicationStatus" slot-scope="props">
            <va-badge :color=computeApplicationStatus(props.rowData.isCreator).color>
              {{ computeApplicationStatus(props.rowData.isCreator).text }}
            </va-badge>
          </template>

          <template slot="actions" slot-scope="props">
            <va-popover message="查看" placement="top">
              <va-button flat small color="gray" icon="fa fa-eye" @click="$router.push({ name: findCoursePath(props.rowData).name, query: findCoursePath(props.rowData).query})" />
            </va-popover>
            <va-popover message="删除" placement="top">
              <va-button flat small color="gray" icon="fa fa-trash"
                @click="deleteModal = true; deleteMentorMtmCourseId=props.rowData.serviceMtmMentorId;deleteServiceType=props.rowData.serviceType;deleteServiceId=props.rowData.course.id;isCreator=props.rowData.isCreator"/>
            </va-popover>
          </template>
        </va-data-table>
        <va-modal
          v-model="deleteModal"
          title="删除审核课程"
          okText="提交"
          position="center"
          message="请再次确认是否要删除？"
          @ok="confirmDelete"
        />
      </va-card>
    </div>
  </div>
</template>

<script>

import { computeAuditStatus, computeServiceType, formatTime } from '../../../utils/common'
import { COURSE_TYPES, SERVICE_AUDIT_TYPE } from '../../../utils/constants'
import mentorApi from '../../../api/mentor'
import auditingCourseApi from '../../../api/auditingCourse'
// import mentorInfoApi from '@/api/mentorInfo'
export default {
  data () {
    return {
      message: ['Required field'],
      // serviceId: 3,
      auditingCourses: [],
      loading: true,
      pageSize: 10,
      pageNumber: 1,
      totalCount: 0,
      totalPages: 1,
      auditStatus: 3,
      serviceType: null,
      statusOptions: SERVICE_AUDIT_TYPE.map(item => { return item.TEXT }),
      serviceAuditTypes: SERVICE_AUDIT_TYPE,
      courseTypes: COURSE_TYPES,
      mentors: {},
      deleteModal: false,
      deleteMentorMtmCourseId: null,
      deleteServiceType: null,
      deleteServiceId: null,
      isCreator: false,
    }
  },
  computed: {
    fields () {
      return [
        {
          name: '__slot:mentorName',
          title: '申请导师',
          width: '16%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: 'course.name',
          title: '课程名称',
          width: '16%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: '__slot:applicationStatus',
          title: '申请形式',
          width: '16%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: '__slot:auditStatusSlot',
          title: '申请状态',
          width: '16%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },

        {
          name: 'createTime',
          title: '创建时间',
          width: '16%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: '__slot:actions',
          title: '操作',
          width: '16%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
      ]
    },
  },
  created () {
    this.listMentorInfo()
    this.listAuditingCourse()
  },
  methods: {
    listAuditingCourse (pageNumber = this.pageNumber) {
      this.loading = true
      const params = {
        pageSize: this.pageSize,
        pageNumber: pageNumber,
        auditStatus: this.auditStatus,
        mentorUid: this.$route.query.mentorUid,
        serviceType: this.serviceType,
      }
      auditingCourseApi.listAuditingCourse(params).then(response => {
        this.auditingCourses = response.auditingCourses
        this.auditingCourses.forEach(x => {
          x.createTime = formatTime(x.createTime)
        })
        this.totalPages = response.pages.totalPage
        this.totalCount = response.pages.totalCount
        this.pageNumber = pageNumber
        this.loading = false
      }).catch(error => alert(error))
    },
    listMentorInfo () {
      this.mentors.libabang = '篱笆官方'
      mentorApi.listMentor().then(response => {
        response.mentors.map(mentor => {
          this.mentors[mentor.uid] = mentor.nickname
        })
      }).catch(error => alert(error))
    },
    handleAuditStatusChange (auditStatus) {
      this.auditStatus = auditStatus
      this.listAuditingCourse()
    },
    handleServiceTypeChange (serviceType) {
      this.serviceType = serviceType
      this.listAuditingCourse()
    },
    computeAuditStatusColor: function (auditStatus) {
      return this.auditStatus === auditStatus ? 'info' : 'gray'
    },
    computeCourseTypeColor: function (serviceType) {
      return this.serviceType === serviceType ? 'info' : 'gray'
    },
    computeStatus: function (auditStatus) {
      return computeAuditStatus(auditStatus)
    },
    computeCourseType: function (courseType) {
      return computeServiceType(courseType)
    },
    computeCreator: function (creatorUid) {
      return this.mentors[creatorUid]
    },
    computeApplicationStatus: function (isCreator) {
      const data = {
        color: 'pink',
      }
      data.text = isCreator ? '创建' : '加入'
      data.color = isCreator ? 'warning' : 'danger'
      return data
    },
    findCoursePath: function (data) {
      const serviceId = data.course.id
      const serviceType = data.serviceType
      const serviceMtmMentorId = data.serviceMtmMentorId
      const auditStatus = data.auditStatus
      const mentorUid = data.mentor.mentorUid
      const res = {
        name: null,
        query: {
          serviceId: null,
          serviceType: null,
          serviceMtmMentorId: null,
          auditStatus: null,
          mentorUid: '',
        },
      }
      COURSE_TYPES.map(x => {
        if (serviceType === x.CODE) {
          res.name = x.AUDIT_COURSE_PATH
          res.query.serviceId = serviceId
          res.query.serviceType = serviceType
          res.query.serviceMtmMentorId = serviceMtmMentorId
          res.query.auditStatus = auditStatus
          res.query.mentorUid = mentorUid
        }
      })
      return res
    },
    confirmDelete() {
      if (this.deleteMentorMtmCourseId === null || this.deleteServiceType == null || this.deleteServiceId == null) return
      const params = {
        serviceId: this.deleteServiceId,
        serviceType: this.deleteServiceType,
        offerType: this.isCreator ? 1 : 2,
      }
      auditingCourseApi.deleteAuditingCourse(this.deleteMentorMtmCourseId, params).then(response => {
        if (response.success === true) {
          this.showToast('删除成功', {
            duration: 1000,
            icon: 'fa-check',
            position: 'top-center',
            fullWidth: false,
          })
          this.listAuditingCourse()
        }
      }).catch(error => {
        this.showToast(error.msg, {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    },
  },
}

</script>
<style lang="scss">
.data-table-server-pagination---avatar {
  width: 60px;
  height: 60px;
  border-radius: 50%;
}
</style>
